module.exports = __webpack_public_path__ + "assets/img/100501.51f84679.svg";